import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const items = [
  { id: "price_1RCZmFJghU42dndggqGQYob8", image: "/mainImages/LSR-Aware-VR.png", price: 15 },
  { id: "price_1RCZmCJghU42dndgtkI3Z7rH", image: "/mainImages/LSR-Pro-VR.png", price: 45 },
  { id: "price_1RCZmAJghU42dndgJag7ftBy", image: "/mainImages/LSR-Roads-VR.png", price: 45 },
  
  { id: "price_1RGJD9JghU42dndgxQyHWhp4", image: "/bundleimages/vrbundleaware.png", price: 100 },

  { id: "price_1RCZm8JghU42dndgQQFnAwNi", image: "/mainImages/Driving-Aware-All-Roads-VR.png", price: 20 },
  { id: "price_1RCZm6JghU42dndgxl33yUmD", image: "/mainImages/DrivingPro-Black-Top-VR.png", price: 40 },
  { id: "price_1RCZm4JghU42dndg5kEKvZ0j", image: "/mainImages/DrivingPro-Graded-Road-VR.png", price: 50 },
  
  { id: "price_1RGJDCJghU42dndgUQqOr1Ym", image: "/bundleimages/vrbundlepro.png", price: 100 },

  { id: "price_1RCZm1JghU42dndgRuA3Si26", image: "/bundleimages/vrprocesssafetylockout.png", price: 100 },
  { id: "price_1RGJCgJghU42dndgk4Gus1fU", image: "/bundleimages/vrprocesssafetygrey.png", price: 0 }


];

const VRPurchasePageBusiness = () => {
  const [quantities, setQuantities] = useState({});
  const navigate = useNavigate();

  const handleQtyChange = (id, value) => {
    if (/^\d*$/.test(value)) {
      if (id === 'price_1RGJCgJghU42dndgk4Gus1fU') {
        alert("Coming Soon! For more information, please contact info@virsatAcademy.com.");
    return; }
      setQuantities((prev) => ({ ...prev, [id]: value ? parseInt(value) : 0 }));
    }
  };

  const totalPrice = items.reduce((total, item) => {
    return total + (quantities[item.id] || 0) * item.price;
  }, 0);

  const handlePurchase = () => {
    const selectedItems = items
      .filter((item) => quantities[item.id] > 0)
      .map((item) => ({ id: item.id, quantity: quantities[item.id] }));
    
    navigate("/checkout", { state: { selectedItems } });
  };

  return (
    <div >
      <h1>Purchase VR  Business License  </h1>
      <div className="checkout-container-business">
        {items.map((item) => (
          <div key={item.id} className="item">
            <img src={item.image} alt="Item" />
            <div className="vr-inputBox">
              <div className="business-text">Qty
                <input
                  type="number"
                  value={quantities[item.id] || ""}
                  onChange={(e) => handleQtyChange(item.id, e.target.value)}
                  min="0"
                />x {`$${item.price}`}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="checkout-calculation-business">
        <div className="sub-cover">

        <div className="sub-checkout">
        <h1 className="checkout-h2">Total: ${totalPrice.toFixed(2)}</h1>
        <button className="body-button" onClick={handlePurchase} disabled={totalPrice === 0}>
          Purchase
        </button>
        <p className="checkout-sub-text"> Discount: Applied at checkout</p>

        </div>
        </div>

        <div className="purchase-text-below"> 

        <p> All VR licenses are valid for 30 days from the date of purchase and allows for 10 game run. Each pin verification at start of game counts as one game run.
        <br/> Please note: A Windows based PC and PICO 4 VR headset is required to install and play these games.</p>

        </div>


      </div>

    </div>
  );
};


export default VRPurchasePageBusiness;
